export const headingLevelByPage = page => page === 'stegProfil' ? 3 : 2;